import PrivacyDialog from './PrivacyDialog';

export default PrivacyDialog;
